import { useState, useEffect, useRef } from "react";
import moment from "moment";

const useCreateProposal = (campaign, deps) => {
  const {
    history,
    fetchingDisplaysInfo,
    clearCampaignData,
    setClient,
    setBrand,
    setDates,
    setProgrammatic,
    setBudget,
    getDisplaysInfoRequest,
  } = deps;

  const [starting, setStarting] = useState(false);
  const prevFetching = useRef(fetchingDisplaysInfo);

  useEffect(() => {
    if (prevFetching.current && !fetchingDisplaysInfo && starting) {
      setStarting(false);
      if (history) history.push("/map");
    }
    prevFetching.current = fetchingDisplaysInfo;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchingDisplaysInfo]);

  const startCreateProposal = () => {
    if (!campaign) return;
    setStarting(true);
    clearCampaignData();
    setClient(campaign.client || {});
    setBrand(campaign.brand || {});
    setProgrammatic(campaign.smart_campaign === 1 ? "programmatic" : "traditional");
    setBudget(parseFloat(campaign.total_price_with_profit) || 0);

    const start_date =
      campaign.start_date && moment(campaign.start_date).format("YYYY-MM-DD");
    const end_date =
      campaign.end_date && moment(campaign.end_date).format("YYYY-MM-DD");
    setDates(start_date, end_date);

    const listDisplays = [
      ...new Set((campaign.contents_displays || []).map((d) => d.display_id)),
    ];

    getDisplaysInfoRequest({
      date_from: start_date,
      date_to: end_date,
      currency: campaign.currency,
      invoice_issuing_country:
        campaign.invoice_issuing && campaign.invoice_issuing.alpha_2_code,
      client_id: campaign.client ? campaign.client.id : null,
      list_id: listDisplays,
      external_dsp_id: campaign.external_dsp_id,
      smart_campaign_enabled: campaign.programmatic_provider_id ? 1 : null,
      is_campaign: 1,
    });
  };

  return { startCreateProposal };
};

export default useCreateProposal;
